"use strict";
/* globals module */
/**
 * @module commerceInvoiceClient
 * @description  Commerce Invoice Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceInvoiceClient` uses `commerceInvoiceRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var __1 = require("../");
var CommerceInvoiceClient = /** @class */ (function () {
    function CommerceInvoiceClient(commerceInvoiceRoute, commerceInvoiceStreamsClient, apiClient) {
        this.commerceInvoiceRoute = commerceInvoiceRoute;
        this.commerceInvoiceStreamsClient = commerceInvoiceStreamsClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceInvoiceClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceInvoiceRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceInvoiceClient.prototype, "streams", {
        get: function () {
            return this.commerceInvoiceStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceInvoiceClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceInvoiceClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceInvoiceClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceInvoiceClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceInvoiceRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceInvoiceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceInvoice);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceInvoice is a resource previously fetched using get action.
                    commerceInvoice.invoiceStatusId : '<new-invoice-status-id>';
                    commerceInvoiceClient.update(commerceInvoice)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceInvoiceClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceInvoiceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceInvoice);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceInvoice is a resource previously fetched using get action.
                        commerceInvoiceClient.remove(commerceInvoice)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceInvoiceClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceInvoiceClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceInvoiceRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceInvoiceStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceInvoiceRoute !== "undefined" && __1.CommerceInvoiceRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceInvoiceStreamsClient !== "undefined" && __1.CommerceInvoiceStreamsClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceInvoiceClient);
    return CommerceInvoiceClient;
}());
exports.CommerceInvoiceClient = CommerceInvoiceClient;
